<template>
    <div class="diasLonchera" :class="{totalizer}">
        <div class="dia" v-for="day in fechasCalculadas" :title="day.dia" :key="day.dia">
            <api-day-toggler-by-launch-box :modo-agenda="modoAgenda" v-if="editMode && isEscuela" :day="day.dia" :cantidad="day.cant" :presencia-id ="uPresenciaId" :select-filters="selectFilters" @reload="$emit('reload')"/>
            <empresa-define-lunch :modo-agenda="modoAgenda" v-else-if="editMode" :day="day.dia" :cantidad="day.cant" :presencia-id ="uPresenciaId" :select-filters="selectFilters" @reload="$emit('reload')"/>
            <template v-else>
                <span class="dimmed" v-if="!day.cant">-</span>
                <span v-else>{{day.cant}}</span>
            </template>
        </div>
        <div class="dia total">
            <span>{{sumLonchera}}</span>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import apiDayTogglerByLaunchBox from './api-day-toggler-by-launch-box.vue'
import EmpresaDefineLunch from './empresaDefineLunch.vue'

moment.locale('es')

const components = { 
    apiDayTogglerByLaunchBox, 
    EmpresaDefineLunch 
}

export default {
	components,
    name: 'diasLonchera',
    props: {
        modoAgenda: {
            type: String,
            default: 'Normal'
        },
        selectFilters: {
            type: Object
        },
        uPresenciaId: {
            type: [String, Number]
        },
        editMode: {
            type: Boolean
        },
        debug: {
            type: Boolean
        },
        dias: {
            type: [Object],
            default: () => {
                return {
                    // 0: 'Domingo',
                    1: 'Lunes',
                    2: 'Martes',
                    3: 'Miércoles',
                    4: 'Jueves',
                    5: 'Viernes',
                    // 6: 'Sábado'
                }
            }
        },
        totalizer: {
            type: Boolean,
            default: false
        },
        fechas: {
            type: Array
        }
    },
    computed: {
        isEscuela(){
            return (this.selectFilters.tipo == 'escuela')
        },
        sumLonchera(){
            let sum = 0;
            _.forEach(this.fechasCalculadas, fCalc => {
                sum += fCalc.cant
            })
            return sum;
        },
        fechasCalculadas(){
            return _.map(this.dias, (dia, diaIndx) => {
                let list = _.filter(this.fechas, (date) => {
                    return (moment(date.fecha_pedido).format('d') == diaIndx);
                }), countItems = 0;
                _.forEach(list, item => {
                    countItems += parseInt(item.cantidad)
                    // console.log('item', item)
                })
                return {
                    dia,
                    list,
                    cant: countItems
                }
            })
        }
    }
}
</script>

<style lang="less">
    .diasLonchera {
        display: flex;
        flex-flow: row;
        height: 100%;
        width: auto; height: 3.5em;
        .dia {
            text-align: center;
            padding: 0.25em 0;
            background: transparent;
            width: 5em;
            border-bottom: none;
            border-top: none;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            span, strong {
                &:not(.dimmed){
                    color: var(--dimmed);
                    opacity: 0.5;
                }
                &.dimmed {
                    opacity: 0.25;
                }
            }
            &.total {
                font-weight: bold;
                background-color: hsla(131, 48%, 65%, 0.2);
            }
        }
        &.totalizer {
            .dia {
                span {
                    color: var(--primary);
                    opacity: 1;
                    font-weight: bold;
                }
            }
        }
    }
</style>